var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},_vm._l((_vm.fieldAttrs),function(ref){
var componentType = ref.componentType;
var name = ref.name;
var attrs = ref.attrs;
var listeners = ref.listeners;
return _c(componentType,_vm._g(_vm._b({key:name,tag:"component"},'component',Object.assign({}, attrs, {name: name}),false),listeners))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }